import { useEffect, useState, useContext } from 'react';
import api from '../api';
import './home.css';
import { UserContext } from '../context/UserContext';

export default function Shops() {
  const { user } = useContext(UserContext);
  const [items, setItems] = useState([]);
  const openShop = async (e, s) => {
    e.preventDefault();
    try { await api.post(`/shops/click/${s.id}`); } catch {}
    window.open(s.url, '_blank', 'noopener');
  };
  useEffect(() => {
    (async () => {
      try {
        const res = await api.get('/shops/public');
        setItems(res.data?.items || []);
      } catch {
        setItems([]);
      }
    })();
  }, []);
  return (
    <div className="home-page">
      <section className={user ? 'hero-offset-if-sidebar' : ''} style={{ width:'100vw', margin:0, padding:0 }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Shops</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>
          Entdecke unsere Partner-Shops. Ausgewählt und kuratiert.
        </p>
      </section>
      <section style={{ width:'100%', maxWidth:1100, margin:'0 auto', padding:'0 16px 40px 16px', color:'#fff' }}>
        {items.length === 0 ? (
          <div style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:16 }}>
            <p style={{ color:'#ddd' }}>Bald verfügbar.</p>
          </div>
        ) : (
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(260px, 1fr))', gap:16 }}>
            {items.map(s => (
              <a key={s.id} href={s.url} onClick={(e)=>openShop(e, s)} target="_blank" rel="noopener noreferrer"
                style={{ display:'block', textDecoration:'none', color:'#fff', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, overflow:'hidden' }}>
                {s.logoUrl && (
                  <div style={{ width:'100%', background:'#111' }}>
                    <img src={s.logoUrl} alt="" style={{ width:'100%', height:'auto', display:'block' }} />
                  </div>
                )}
                <div style={{ padding:12 }}>
                  {!s.logoUrl && (
                    <div style={{ width:'100%', height:80, borderRadius:8, background:'#222', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:8 }}>
                      <span style={{ fontSize:24, fontWeight:700 }}>{s.name?.[0]?.toUpperCase()||'S'}</span>
                    </div>
                  )}
                  <div style={{ fontWeight:600 }}>{s.name}</div>
                  {s.description && <div style={{ fontSize:12, color:'#bbb', marginTop:4 }}>{s.description}</div>}
                </div>
              </a>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
